// extracted by mini-css-extract-plugin
export var anchor = "_52-0";
export var discard = "_52-4";
export var muiTooltipTooltip = "_52-6";
export var notificationBar = "_52-3";
export var saveButtonHoverSlotWrapper = "_52-5";
export var show = "_52-2";
export var spacer = "_52-1";